module.exports = __webpack_public_path__ + "media/images/icons/language-570b96bcc29bb35c316b7a5a64917273.svg";